module.exports = __webpack_public_path__ + "static/media/steering_wheel.1403969e.svg";